enum PhoneNumbers {
  EZDISPATCH_DIRECT = '1-800-488-2085',
  TWILIO_SMS_OPT_IN = '1-855-699-0551',
}

export default PhoneNumbers;
